import { useRootSelector } from '../../store/hooks';
import {
  selectPageConfig,
  TenantDomainId,
} from '../../store/features/pageConfig';
import { SiteTypes } from '../../types';
import { generateDomainUrl } from '../../helpers/generateDomainUrl';

export function useCreateArticleCanonicalUrl(
  primarySitePath: string,
  siteType: SiteTypes,
  tenant: TenantDomainId,
  articlePath: string,
) {
  const { tenantsConfig } = useRootSelector(selectPageConfig);
  const path =
    siteType === SiteTypes.EVENT || siteType === SiteTypes.COURSE
      ? `${primarySitePath}/article/${articlePath}`
      : `${articlePath}`;
  const url = generateDomainUrl({
    domains: tenantsConfig,
    tenant,
    path,
  });

  return url.replace(/([^:]\/)\/+/g, '$1');
}
